export const stateName = (slug) =>
  slug === "district-of-columbia" ? "Washington, D.C." : slug.split("-").map((w) => w[0].toUpperCase() + w.slice(1)).join(" ");
